import React from 'react'
import { useTranslation } from 'react-i18next'

import * as S from './styles'

const SectionOrders: React.FC = () => {
  const { t } = useTranslation('admin')

  return (
    <S.Container>
      <S.OrdersTitle>{t('section_orders.title')}</S.OrdersTitle>
    </S.Container>
  )
}

export default SectionOrders
